import { useState, useEffect, useCallback } from "react";

/*
 * Modo "ocultar valores internos" (👁️).
 * Quando ativo, todas as telas escondem lucro, margem, custos e dados
 * financeiros internos — mostrando apenas o preço final ao cliente.
 *
 * O estado é global (localStorage) e sincronizado em tempo real entre
 * todos os componentes via um CustomEvent, para que a ocultação seja
 * instantânea em qualquer tela aberta.
 */

const KEY = "3dp_ocultar_valores";
const EVT = "3dp-ocultar-valores-change";

export function getOcultarValores() {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function setOcultarValores(valor) {
  try { localStorage.setItem(KEY, valor ? "1" : "0"); } catch {}
  window.dispatchEvent(new Event(EVT));
}

export function useOcultarValores() {
  const [ocultar, setOcultar] = useState(getOcultarValores);

  useEffect(() => {
    const handler = () => setOcultar(getOcultarValores());
    window.addEventListener(EVT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(EVT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const toggle = useCallback(() => setOcultarValores(!getOcultarValores()), []);

  return [ocultar, toggle];
}
